module.exports = __webpack_public_path__ + "img/zhihu.848314c9.png";